import React from 'react';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import {
  Formik, Form as FormikForm,
} from 'formik';

import {
  DateField,
  SubmitButton,
  CancelPopupButton,
} from 'ui/FormElement';

import Actions from './Actions';

export default function Form({ enterpriseId, onClose }) {
  const formSchema = Yup.object().shape({
    blockDate: Yup.date().required('Date is required').typeError('Date is required'),
  });

  const onSubmit = (values, { setSubmitting, setErrors }) => {
    Actions.block(enterpriseId, values, (errorData) => {
      const newErrors = {};
      errorData.errors.forEach((item) => {
        newErrors[item.source.replace('/data/attributes/', '')] = item.detail;
      });
      setErrors(newErrors);
      setSubmitting(false);
    });
  };

  return (
    <Formik
      enableReinitialize
      validationSchema={formSchema}
      initialValues={{ blockDate: null }}
      onSubmit={onSubmit}
    >
      {({ isSubmitting, values, setFieldValue }) => (
        <FormikForm className="needs-validation" noValidate="">
          <DateField
            name="blockDate"
            label={(
              <>
                <span>Block Date</span>
                <abbr title="required">*</abbr>
              </>
            )}
          />

          <div className="text-center mt50 mb30">
            <CancelPopupButton
              className="btn btn-primary btn-outline mr5 ml5 width-120"
              title="Cancel"
              onClick={onClose}
            />
            <SubmitButton
              title={isSubmitting ? 'Please, wait ...' : 'Block'}
              className={`btn width-120 btn-primary submit-button mr5 ml5 ${
                isSubmitting ? 'not-possible-click' : ''
              }`}
            />
          </div>
        </FormikForm>
      )}
    </Formik>
  );
}

Form.propTypes = {
  enterpriseId: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
};
